import React from 'react';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import SelectFilter from 'components/ReactTable/Filters/SelectFilter';
import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import Chapter3Status from 'common/Customers/Chapter3Status';
import Chapter4Status from 'common/Customers/Chapter4Status';
import CRSClassificationStatus from 'common/Customers/CRSClassificationStatus';
import GetOptions from './GetOptions';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const customerColumnDefs = permissions => [
  {
    Header: 'Customer',
    accessor: 'customer',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="itemId" data={ original } permissions={ permissions } />);
    },
    className: 'col-17p'
  },
  {
    Header: 'Email Address',
    accessor: 'emailAddress',
    className: 'col-10p'
  },
  {
    Header: 'Account',
    accessor: 'account',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<AccountLinkCell dataKey="accountId" data={ original } permissions={ permissions } />);
    },
    className: 'col-15p'
  },
  {
    Header: 'Ch. 3 Status',
    accessor: 'chapter3StatusDescription',
    Filter: MultiSelectFilter,
    options: Chapter3Status.map(item => ({ value: item.name, title: item.description })).sort((a, b) => (a.title > b.title ? 1 : -1)),
    className: 'col-10p'
  },
  {
    Header: 'Ch. 4 Status',
    accessor: 'chapter4StatusDescription',
    Filter: MultiSelectFilter,
    options: Chapter4Status.map(item => ({ value: item.name, title: item.description })).sort((a, b) => (a.title > b.title ? 1 : -1)),
    className: 'col-10p'
  },
  {
    Header: 'CRS Classification',
    accessor: 'crsClassificationDescription',
    Filter: MultiSelectFilter,
    options: CRSClassificationStatus.map(item => ({ value: item.name, title: item.description })).sort((a, b) => (a.title > b.title ? 1 : -1)),
    className: 'col-10p'
  },
  {
    Header: 'Is Active?',
    accessor: 'isActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-10p'
  },
  {
    Header: 'Is Direct?',
    accessor: 'isDirect',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isDirect'),
    className: 'col-10p'
  },
  {
    Header: 'Item Id',
    accessor: 'itemId',
    isVisible: false
  }
];

export default customerColumnDefs;
